import {style} from 'typestyle'
import * as csstips from 'csstips'

export const HotSearchModule = style({
    display: 'block'
})

export const HotSearchModuleTitleWrap = style({
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.betweenJustified,
    padding: '13px 15px 13px 15px'
})

export const HotSearchModuleTitle = style({
    fontSize: 18,
    color: '#000000',
    lineHeight: '22px',
    fontWeight: 500
})

export const hotSearchList = style({

})

export const hotSearchListTitle = style({
    fontSize: 16,
    color: '#333333',
    lineHeight: '20px',
    width: '48vw',
    maxWidth: 230.4,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
})

export const hotSearchListTitleWrap = style({
    ...csstips.flexRoot,
    ...csstips.center
})

export const hotSearchListItem = style({
    ...csstips.flexRoot,
    ...csstips.betweenJustified,
    ...csstips.center,
    padding: '13px 15px 13px 15px',
    cursor: 'pointer',
    $nest: {
        '&:active': {
            background: '#f0f0f0'
        }
    }
})

export const popularNums = style({
    position: 'relative',
    fontSize: 14,
    color: '#999999',
    lineHeight: '18px',
    $nest: {
        '&::after': {
            'content': `""`,
            'position': 'absolute',
            'left': -15,
            'backgroundImage': 'url(https://static-1253442168.image.myqcloud.com/picture/11285307_a5e866831de628f919446acb38b9a549.jpg)',
            'backgroundRepeat': 'no-repeat',
            'backgroundSize': '100% 100%',
            'width': 10,
            'height': 11,
            'top': '50%',
            'transform': 'translateY(-50%)',
            '-webkit-transform': 'translateY(-50%)'
        }
    }
})

export const hotSearchListIndex = style({
    fontSize: 18,
    color: '#676767',
    textAlign: 'center',
    lineHeight: '22px',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    width: 22,
    height: 22,
    marginRight: 10
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSearchPage/HotSearch/HotSearchModule.style.ts